module.exports = __webpack_public_path__ + "img/back_page.9bcd5546.svg";